import React, { Component } from 'react';
import { withStyles, Grid, Button } from '@material-ui/core';
import buttonImage from '../resources/Images/retake.png';
import buttonImageStyle from '../resources/Images/browse_styles.png';

const styles = theme => ({
    wrapper: {
        display: "flex",
        justifyContent: "center",
        marginTop: '8%'
    },
    box: {
        width: "950px !important",
        alignItems: "flex-start"
    },
    h3: {
        fontSize: '1.5em',
        fontWeight: '600',
        marginBottom: '60px'
    },
    conteinerBox: {
        padding: '0 25px'
    },
    p: {
        fontWeight: '300',
        fontStyle: 'italic',
        fontSize: '15px',
        marginTop: '50px'
    },
    span: {
        background: 'rgba(0,0,0,.75)',
        color: '#fff',
        padding: '.3em .6em',
        fontSize: '1.875em',
        fontWeight: '700',
        position: 'absolute',
        marginTop: '1em',
        zIndex: '999'
    },
    img: {
        position: 'absolute',
        marginTop: '-3.4em',
        marginLeft: '6em',
        width: '250px',
        zIndex: '1'
    },
    button: {
        '&:hover': {
            opacity: '0.7 !important',
            backgroundColor: 'transparent'
        }
    }
});

class ResultComponent extends Component {
    render() {
        const { classes, history, primaryStyle, secondaryStyle, cssOpen } = this.props;
        if (!primaryStyle) {
            return (<div>Loading...</div>)
        }

        let bg1 = `https://s3.amazonaws.com/events.gemvision.com/${primaryStyle.BACKGROUNDPATH}`
        let bg2 = `https://s3.amazonaws.com/events.gemvision.com/${secondaryStyle.BACKGROUNDPATH}`

        let image1 = `https://s3.amazonaws.com/events.gemvision.com/${primaryStyle.RENDERPATH}`
        let image2 = `https://s3.amazonaws.com/events.gemvision.com/${secondaryStyle.RENDERPATH}`

        let resultString = `${primaryStyle.LABEL},${secondaryStyle.LABEL}`

        return (
            <div className={classes.wrapper}>
                <p style={{ display: 'none' }} id='result'> {resultString}</p>
                <Grid container className={classes.box}>
                    <Grid container item xs={6} className={classes.conteinerBox} style={{ borderRight: '1px solid #93d0f2' }} >
                        <h3 className={classes.h3}>Your jewelry design style is ...</h3>
                        <div style={{ background: `url(${bg1}) center center`, backgroundSize: 'cover', height: '90px', width: '100%', border: '1px solid #2c2b29' }}>
                            <Grid container >
                                <Grid container item xs={2} >
                                    <span className={classes.span}>{primaryStyle.LABEL}</span>
                                </Grid>
                                <Grid container item xs={10}>
                                    <img src={image1} className={classes.img} alt="icon export" />
                                </Grid>
                            </Grid>
                        </div>
                        <p className={classes.p}> {primaryStyle.DESCRIPTION}</p>
                    </Grid>

                    <Grid container item xs={6} className={classes.conteinerBox} >
                        <h3 className={classes.h3}>With a touch of ...</h3>
                        <div style={{ background: `url(${bg2}) center center`, backgroundSize: 'cover', height: '90px', width: '100%', border: '1px solid #2c2b29' }}>
                            <Grid container >
                                <Grid container item xs={2} >
                                    <span className={classes.span}>{secondaryStyle.LABEL}</span>
                                </Grid>
                                <Grid container item xs={10}>
                                    <img src={image2} className={classes.img} alt="icon export" />
                                </Grid>
                            </Grid>
                        </div>
                        <p className={classes.p}> {secondaryStyle.DESCRIPTION}</p>
                    </Grid>
                    <Grid container item xs={12} justify="center" style={{ marginTop: '50px' }}>
                        <Button
                            size="small"
                            className={classes.button}
                            onClick={e => {
                                history.push(`/steps`);
                            }}>
                            <img src={buttonImage} style={{maxWidth:'200px'}} size="tidy" alt="icon export" />
                        </Button>
                        {cssOpen ?
                            <Button
                                size="small"
                                className={classes.button}
                                onClick={e => {
                                    history.push(`#browse`);
                                    window.location = 'result#browse'
                                }}>
                                <img src={buttonImageStyle} style={{maxWidth:'200px'}} size="tidy" alt="icon export" />
                            </Button>
                            : null}
                    </Grid>
                </Grid>
            </div>
        );
    }
}

export default withStyles(styles)(ResultComponent);

